import { z } from "zod";

export const positionFlowsheetFormSchema = z.object({
  positionDate: z.date().nullable(),
  positionTime: z.string().nullable(),
  clientPosition: z.string().nullable().optional(),
  clientInWater: z.string().nullable().optional(),
  clientInWaterOther: z.string().optional(),
  positionNotes: z.string().optional(),
  signatureInitials: z.array(z.string()).optional(),
});

export type PositionFlowsheetFormSchemaType = z.infer<typeof positionFlowsheetFormSchema>;
